import request from '@/utils/ajax';

export function saveWechatServer(data){
  return request({
    url: `/wx/manage/wxBotApiConfig/save`,
    method: 'POST',
    data: data
  });
}

export function updateWechatServer(data){
  return request({
    url: `/wx/manage/wxBotApiConfig/update`,
    method: 'PUT',
    data: data
  });
}


